import { useRef } from 'react'

import { preventDefault } from '../../../utils/events'

import { getRentalPortalViewRegimeNextArrowOption } from './RentalPortalViewRegimeControl.utils'
import { RentalPortalViewRegimeControlOption } from './RentalPortalViewRegimeControlOption'

import * as styles from './RentalPortalViewRegimeControl.module.css'

function RentalPortalViewRegimeControl({ listViewType, options, onChange }) {
  const containerRef = useRef(null)

  function handleKeyDown(event) {
    const nextOption = getRentalPortalViewRegimeNextArrowOption({
      container: containerRef.current,
      event,
    })

    if (nextOption) {
      preventDefault(event)

      nextOption.focus()
    }
  }

  return (
    <div className={styles.RentalPortalViewRegimeControl} ref={containerRef}>
      {options.map(option => (
        <RentalPortalViewRegimeControlOption
          key={option.name}
          listViewType={listViewType}
          option={option}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
      ))}
    </div>
  )
}

export default RentalPortalViewRegimeControl
